module.exports = __webpack_public_path__ + "colourfi_logo.2f18f71ef76223b67474c3fad5b14da1.png";